import { create } from "zustand";
import { persist } from "zustand/middleware";

type DossierPinStore = {
    pinnedDossierIds: number[];
    isPinned: (dossierId: number) => boolean;
    unpin: (dossierId: number) => void;
    togglePin: (dossierId: number, openDossierIds: number[]) => void;
};

export const useDossierPinStore = create<DossierPinStore>()(
    persist(
        (set, get) => ({
            pinnedDossierIds: [],
            isPinned: (dossierId: number) => get().pinnedDossierIds.includes(dossierId),
            unpin: (dossierId: number) => {
                set((state) => ({
                    pinnedDossierIds: state.pinnedDossierIds.filter((id) => id !== dossierId),
                }));
            },
            togglePin: (dossierId: number, openDossierIds: number[]) => {
                set((state) => {
                    const reconciled = state.pinnedDossierIds.filter((id) => openDossierIds.includes(id));

                    if (reconciled.includes(dossierId)) {
                        return { pinnedDossierIds: reconciled.filter((id) => id !== dossierId) };
                    }

                    // Only open dossiers can be pinned.
                    if (!openDossierIds.includes(dossierId)) {
                        return { pinnedDossierIds: reconciled };
                    }

                    return { pinnedDossierIds: [...reconciled, dossierId] };
                });
            },
        }),
        {
            name: "dossier-pins",
        }
    )
);
